import { render, staticRenderFns } from "./AdminDataRestrictions.vue?vue&type=template&id=0fcd3201&"
import script from "./AdminDataRestrictions.vue?vue&type=script&lang=js&"
export * from "./AdminDataRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports